import React from 'react'
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from './components/home/Home';
import Aboutus from './components/aboutus/Aboutus';
import Acadamics from './components/Acadamics/Acadamics';
import Contactus from './components/contactus/Contactus';
import Departments from './components/departments/Department';
import Events from './components/events/Events';
import Hostel from './components/hostel/Hostel';
import Login from './components/events/code/login';
import LoginPage from './components/admin/LoginPage';
import Adminhomepage from './components/admin/Adminhomepage';
import Upload from './components/events/code/Upload';
import Acadamicsadmin from './components/admin/Acadamics';
import News from './components/admin/News';
import Adminhostel from './components/admin/AdminHostel';
import Generaldepartment from './components/admin/Generaldepartment';
import Cmedepartment from './components/admin/Cmedepartment';
import Ecedepartment from './components/admin/Ecedepartment';
import Eeedepartment from './components/admin/Eeedepartment';
import Mechdepartment from './components/admin/Mechdepartment';
import Cmedeptevents from './components/admin/Cmedeptevents';
import Ecedeptevents from './components/admin/Ecedeptevents';
import Eeedeptevents from './components/admin/Eeedeptevents';
import Mechdeptevents from './components/admin/Mechdeptevents';
import Generaldeptevents from './components/admin/Generaldeptevents';
import Principal from './components/admin/Principal';
import Cse from './components/departments/cse';
import Ece from './components/departments/Ece';
import Mech from './components/departments/Mech';
import Eee from './components/departments/Eee';
import General from './components/departments/General';
import Forgot from './components/admin/Forgot';
import Contactform from './components/admin/Contactform';
import Departmentlogininfo from './components/admin/Departmentlogininfo';
import Studentsdetails from './components/admin/Studentdetails';
import Collage from './components/admin/Collage';
const App = () => {
  return (
    <div>
      <title>Gptkpm</title>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Aboutus" element={<Aboutus />} />
          <Route path="/Acadamics" element={<Acadamics />} />
          <Route path="/Contactus" element={<Contactus />} />
          <Route path="/Departments" element={<Departments />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Hostel" element={<Hostel />} />
          <Route path="/Admin" element={<LoginPage />} />
          <Route path="/Login" element={<Login/>}/>
          <Route path="/AdminDashboard" element={<Adminhomepage />} />
          <Route path="/Upload" element={<Upload />} />
          <Route path="/AdminAcadamics" element={<Acadamicsadmin />} />
          <Route path="/News" element={<News />} />
          <Route path="/Adminhostel" element={<Adminhostel />} />
          <Route path="/Generaldepartment" element={<Generaldepartment />} />
          <Route path="/Cmedepartment" element={<Cmedepartment />} />
          <Route path="/Ecedepartment" element={<Ecedepartment />} />
          <Route path="/Eeedepartment" element={<Eeedepartment />} />
          <Route path="/Mechdepartment" element={<Mechdepartment />} />
          <Route path="/Cmedeptevents" element={<Cmedeptevents />} />
          <Route path="/Ecedeptevents" element={<Ecedeptevents />} />
          <Route path='/Eeedeptevents' element={<Eeedeptevents />} />
          <Route path='/Mechdeptevents' element={<Mechdeptevents />} />
          <Route path='/Generaldeptevents' element={<Generaldeptevents />} />
          <Route path='/Principal' element={<Principal/>}/>
          <Route path='/Cse' element={<Cse/>}/>
          <Route path='/Ece' element={<Ece/>}/>
          <Route path='/Mech' element={<Mech/>}/>
          <Route path='/Eee' element={<Eee/>}/>
          <Route path='/General' element={<General/>}/>
          <Route path='/Forgot' element={<Forgot/>}/>
          <Route path='/Contactform' element={<Contactform/>}/>
           <Route path='/Departmentlogininfo' element={<Departmentlogininfo/>}/>
           <Route path='/Studentdetails' element={<Studentsdetails/>}/>
           <Route path='/Collage' element={<Collage/>}/>
        </Routes>
        </HashRouter>
    </div>
  )
}

export default App
